import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/board/excel_ico.png'
import _imports_1 from '@/assets/board/delete_ico.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { id: "board_layer" }
const _hoisted_6 = { class: "board_top" }
const _hoisted_7 = { class: "board_top_btns" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "엑셀다운로드", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "count" }
const _hoisted_12 = { class: "board_list no_filter" }
const _hoisted_13 = { class: "board_table" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { width: "5%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "40%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "5%" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "연번"),
    /*#__PURE__*/_createElementVNode("th", null, "담당자"),
    /*#__PURE__*/_createElementVNode("th", null, "플랫폼"),
    /*#__PURE__*/_createElementVNode("th", null, "제목"),
    /*#__PURE__*/_createElementVNode("th", null, "검색일시"),
    /*#__PURE__*/_createElementVNode("th", null, "탐지건수"),
    /*#__PURE__*/_createElementVNode("th", null, "상세보기"),
    /*#__PURE__*/_createElementVNode("th", null, "삭제")
  ])
], -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "search_txt_box" }
const _hoisted_19 = { class: "total_count" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  type: "button",
  class: "delete_btn"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { colspan: "14" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { colspan: "14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_NoResult = _resolveComponent("NoResult")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Filter, {
                sns: false,
                resultType: false,
                resultDetailType: false,
                nation: false,
                isMonitoring: false,
                type: false,
                platform: true,
                selectOption: $setup.state.selectOption,
                onSearch: $setup.filterSearch,
                onReset: $setup.resetSearch
              }, null, 8, ["selectOption", "onSearch", "onReset"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn board_ico_btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.excelDownLoad && $setup.excelDownLoad(...args)))
                  }, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createTextVNode(" 총 "),
                  _createElementVNode("span", null, _toDisplayString($setup.numberFormat($setup.state.totalLength)) + "건", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _hoisted_14,
                  _hoisted_15,
                  (!$setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.data, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(item.idx), 1),
                            _createElementVNode("td", null, _toDisplayString(item.uniqueName), 1),
                            _createElementVNode("td", null, _toDisplayString(item.platform), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(item.title.length > 30 ? 'more_txt' : ''),
                                onClick: ($event: any) => ($setup.moreText(item.title))
                              }, _toDisplayString(item.title), 11, _hoisted_17)
                            ]),
                            _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.createDate)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, " 총 " + _toDisplayString(item.cnt ? $setup.numberFormat(item.cnt) : 0) + " 건 ", 1)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "blue_btn",
                                onClick: ($event: any) => ($setup.resultBtn(item.idx))
                              }, "탐지결과", 8, _hoisted_20)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", _hoisted_21, [
                                _createElementVNode("img", {
                                  src: _imports_1,
                                  alt: "",
                                  onClick: ($event: any) => ($setup.remove(item.idx))
                                }, null, 8, _hoisted_22)
                              ])
                            ])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.list.data.length === 0 && !$setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_24, [
                            _createVNode(_component_NoResult)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_25, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_26, [
                            _createVNode(_component_Spinner)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_PageBtn, {
                currentPage: $setup.state.currentPage,
                totalLength: $setup.state.totalLength,
                perPage: $setup.state.perPage,
                onOnPaging: $setup.handlePageChange
              }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Popup, {
      show: $setup.state.isPopupOpen,
      title: $setup.modal.title,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "title", "content", "onClose"])
  ], 64))
}